import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { validateEmail, validatePassword } from '../utils/validators';
import { apiLogin } from '../services/api';

// USESTATE é um hook do React que permite adicionar estado a componentes funcionais. Ele retorna um par de valores: o estado atual e uma função para atualizá-lo.
// No código acima, useState é usado para gerenciar o estado dos campos de email e senha, erros de validação, mensagens de erro e sucesso da API, e o estado de carregamento durante a submissão do formulário.

function LoginForm() {
  const { login } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [errors, setErrors] = useState({});
  const [apiError, setApiError] = useState('');
  const [apiSuccess, setApiSuccess] = useState('');
  const [loading, setLoading] = useState(false);

  const validate = () => {
    const newErrors = {};
    const emailErr = validateEmail(email);
    const passErr = validatePassword(password);
    if (emailErr) newErrors.email = emailErr;
    if (passErr) newErrors.password = passErr;
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setApiError('');
    setApiSuccess('');

    if (!validate()) return;

    setLoading(true);
    try {
      const data = await apiLogin(email, password);
      if (data.error) {
        setApiError(data.error);
      } else {
        setApiSuccess(`Bem-vindo(a), ${data.user.email}!`);
        if (data.user && data.token) {
          login(data.user, data.token);
        }
      }
    } catch {
      setApiError('Não foi possível conectar ao servidor.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} noValidate>
      {apiError && <p className="api-error">{apiError}</p>}
      {apiSuccess && <p className="api-success">{apiSuccess}</p>}

      <div className="form-group">
        <label htmlFor="login-email">Email</label>
        <input
          id="login-email"
          type="email"
          placeholder="seu@email.com"
          className={errors.email ? 'input-error' : ''}
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        {errors.email && <p className="field-error">{errors.email}</p>}
      </div>

      <div className="form-group">
        <label htmlFor="login-password">Senha</label>
        <div className="password-input-wrapper">
          <input
            id="login-password"
            type={showPassword ? 'text' : 'password'}
            placeholder="Sua senha"
            className={errors.password ? 'input-error' : ''}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <button
            type="button"
            className="password-toggle-btn"
            onClick={() => setShowPassword((prev) => !prev)}
            aria-label={showPassword ? 'Ocultar senha' : 'Mostrar senha'}
          >
            {showPassword ? 'Ocultar' : 'Mostrar'}
          </button>
        </div>
        {errors.password && <p className="field-error">{errors.password}</p>}
      </div>

      <button type="submit" className="submit-btn" disabled={loading}>
        {loading ? 'Confirmando...' : 'Confirmar acesso'}
      </button>
    </form>
  );
}

export default LoginForm;
